/* Furnitex – tema davranışları */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const FX = window.FX || { routes: {}, t: {} };
  const root = (FX.routes.cart || "/cart").replace(/cart$/, "");

  /* ---------- Para formatı ---------- */
  const money = cents => {
    const fmt = FX.money || "€{{amount}}";
    const n = (cents / 100).toFixed(2);
    const withComma = n.replace(".", ",");
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) =>
      k === "amount_with_comma_separator" ? withComma : k === "amount_no_decimals" ? Math.round(cents / 100) : n);
  };

  /* ---------- Toast ---------- */
  let toastT;
  const toast = msg => {
    const el = $("#fx-toast"); if (!el) return;
    el.textContent = msg; el.classList.add("is-on");
    clearTimeout(toastT); toastT = setTimeout(() => el.classList.remove("is-on"), 2600);
  };

  /* ---------- Çekmeceler ---------- */
  let lastFocus = null;
  const openDrawer = id => {
    const d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    d.hidden = false; document.body.classList.add("fx-lock");
    requestAnimationFrame(() => d.classList.add("is-open"));
    setTimeout(() => ($("button, a, input", $(".fx-drawer__panel", d)) || d).focus(), 50);
  };
  const closeDrawer = d => {
    d.classList.remove("is-open"); document.body.classList.remove("fx-lock");
    setTimeout(() => { d.hidden = true; }, 300);
    lastFocus && lastFocus.focus && lastFocus.focus();
  };
  document.addEventListener("click", e => {
    const o = e.target.closest("[data-drawer-open]");
    if (o) { e.preventDefault(); openDrawer(o.dataset.drawerOpen); return; }
    const c = e.target.closest("[data-drawer-close]");
    if (c) { const d = c.closest("[data-drawer]"); d && closeDrawer(d); }
  });
  document.addEventListener("keydown", e => {
    if (e.key !== "Escape") return;
    $$("[data-drawer].is-open").forEach(closeDrawer);
    closeMega(); closeFilters();
  });

  /* ---------- Mega menü ---------- */
  const megaBtn = $("[data-mega-toggle]"), mega = $("[data-mega]");
  const closeMega = () => { if (mega && !mega.hidden) { mega.hidden = true; megaBtn.setAttribute("aria-expanded", "false"); } };
  if (megaBtn && mega) {
    megaBtn.addEventListener("click", () => {
      const open = mega.hidden; mega.hidden = !open; megaBtn.setAttribute("aria-expanded", String(open));
    });
    $$("[data-mega-item]", mega).forEach(li => {
      const act = () => { $$("[data-mega-item].is-active", mega).forEach(x => x.classList.remove("is-active")); li.classList.add("is-active"); };
      li.addEventListener("mouseenter", act);
      li.querySelector(".fx-mega__top").addEventListener("focus", act);
    });
    document.addEventListener("click", e => { if (!mega.hidden && !e.target.closest("[data-mega], [data-mega-toggle]")) closeMega(); });
  }

  /* ---------- Anlık arama (kod veya ad) ---------- */
  $$("[data-predictive]").forEach(form => {
    const input = $("[data-predictive-input]", form), box = $("[data-predictive-results]", form);
    if (!input || !box || !FX.routes.predictive) return;
    let t, ctrl;
    const hide = () => { box.hidden = true; };
    input.addEventListener("input", () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) return hide();
      t = setTimeout(async () => {
        ctrl && ctrl.abort(); ctrl = new AbortController();
        try {
          const url = `${FX.routes.predictive}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][fields]=title,variants.sku,vendor,product_type,tag&resources[options][unavailable_products]=last`;
          const r = await fetch(url, { signal: ctrl.signal }); const j = await r.json();
          const items = j.resources?.results?.products || [];
          const ql = q.toLowerCase();
          box.innerHTML = items.length ? items.map(p => {
            const v = (p.variants || []).find(x => (x.sku || "").toLowerCase().includes(ql)) || (p.variants || [])[0] || {};
            const img = p.featured_image?.url || p.image || "";
            return `<a class="fx-predictive__item" href="${p.url}">
              ${img ? `<img src="${img}${img.includes("?") ? "&" : "?"}width=120" alt="" loading="lazy" width="52" height="52">` : "<span></span>"}
              <span class="fx-predictive__t">${v.sku ? `<span class="fx-code">${esc(v.sku)}</span>` : ""}${esc(p.title)}</span>
              <span class="fx-predictive__p">${p.price ? money(Math.round(parseFloat(p.price) * 100)) : ""}</span></a>`;
          }).join("") + `<a class="fx-predictive__all" href="${FX.routes.search}?type=product&options[prefix]=last&q=${encodeURIComponent(q)}">${FX.t.allResults} →</a>`
            : `<div class="fx-predictive__none">${FX.t.noResults}</div>`;
          box.hidden = false;
        } catch (e) { if (e.name !== "AbortError") hide(); }
      }, 180);
    });
    document.addEventListener("click", e => { if (!form.contains(e.target)) hide(); });
    input.addEventListener("focus", () => { if (box.innerHTML && input.value.trim().length > 1) box.hidden = false; });
  });
  function esc(s) { return String(s ?? "").replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c])); }

  /* ---------- Sepet ---------- */
  async function refreshCart(open) {
    try {
      const r = await fetch(`${root}?sections=cart-drawer-items`); const j = await r.json();
      const html = new DOMParser().parseFromString(j["cart-drawer-items"], "text/html");
      const wrap = html.querySelector("[data-cart-count-value]");
      const count = +wrap.dataset.cartCountValue;
      $$("[data-cart-items]").forEach(el => { el.innerHTML = wrap.innerHTML; });
      $$("[data-cart-count]").forEach(el => { el.textContent = count; el.hidden = count === 0; });
      $$("[data-cart-count-text]").forEach(el => { el.textContent = `(${count})`; });
      $$("[data-cart-total]").forEach(el => { el.innerHTML = wrap.dataset.cartTotalValue; });
      $$("[data-cart-foot]").forEach(el => { el.hidden = count === 0; });
      const btn = $(".fx-cartbtn"); if (btn) { btn.classList.remove("is-bump"); void btn.offsetWidth; btn.classList.add("is-bump"); }
      if (open && $("[data-cart-drawer]")) openDrawer("fx-cart");
    } catch (e) { location.href = FX.routes.cart; }
  }
  async function addToCart(id, quantity, btn) {
    btn && btn.classList.add("is-loading"); btn && (btn.disabled = true);
    try {
      const r = await fetch(`${FX.routes.cartAdd}.js`, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: +id, quantity: +quantity || 1 }] }) });
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || j.message || FX.t.error);
      toast(FX.t.added);
      await refreshCart(document.body.dataset.cartDrawer !== "false");
    } catch (e) { toast(e.message || FX.t.error); }
    finally { if (btn) { btn.classList.remove("is-loading"); btn.disabled = false; } }
  }
  async function changeLine(key, quantity) {
    const items = $$("[data-cart-items]"); items.forEach(el => el.style.opacity = ".5");
    try {
      const r = await fetch(`${FX.routes.cartChange}.js`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: key, quantity: Math.max(0, +quantity) }) });
      if (!r.ok) throw new Error((await r.json()).description);
      await refreshCart(false);
    } catch (e) { toast(e.message || FX.t.error); }
    items.forEach(el => el.style.opacity = "");
  }
  document.addEventListener("click", e => {
    const q = e.target.closest("[data-quick-add]");
    if (q) { e.preventDefault(); addToCart(q.dataset.quickAdd, 1, q); return; }
    const c = e.target.closest("[data-qty-change]");
    if (c) { e.preventDefault(); changeLine(c.dataset.qtyChange, c.dataset.qty); }
  });
  document.addEventListener("change", e => {
    const i = e.target.closest("[data-qty-input]");
    if (i) changeLine(i.dataset.qtyInput, i.value);
  });

  /* ---------- Ürün sayfası ---------- */
  const pdp = $("[data-product]");
  if (pdp) {
    const data = JSON.parse($("[data-product-json]").textContent);
    const form = $("[data-product-form]", pdp);
    const idInput = $("[data-variant-id]", pdp);
    const selects = $$("[data-option-index]", pdp);
    const addBtn = $("[data-add-btn]", pdp), addLabel = $("[data-add-label]", pdp);
    const qty = $("[data-qty]", pdp);
    const desc = $("[data-desc]");
    let rows = [];

    // galeri
    const show = mediaId => {
      if (!mediaId) return;
      $$(".fx-gallery__slide", pdp).forEach(s => s.classList.toggle("is-active", s.dataset.mediaId == mediaId));
      $$(".fx-gallery__thumb", pdp).forEach(t => t.classList.toggle("is-active", t.dataset.thumb == mediaId));
      const th = $(`.fx-gallery__thumb[data-thumb="${mediaId}"]`, pdp); th && th.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" });
    };
    $$(".fx-gallery__thumb", pdp).forEach(t => t.addEventListener("click", () => show(t.dataset.thumb)));

    // miktar
    $$("[data-step]", pdp).forEach(b => b.addEventListener("click", () => { qty.value = Math.max(1, (+qty.value || 1) + +b.dataset.step); }));

    const setVariant = (v, fromTable) => {
      if (!v) {
        addBtn.disabled = true; addLabel.textContent = FX.t.unavailable; return;
      }
      idInput.value = v.id;
      $("[data-sku]", pdp).textContent = v.sku || "";
      const wrap = $("[data-price-wrap]", pdp);
      $("[data-price]", wrap).textContent = money(v.price);
      const cmp = $("[data-compare]", wrap);
      const sale = v.compare > v.price;
      cmp.hidden = !sale; cmp.textContent = sale ? money(v.compare) : "";
      wrap.classList.toggle("is-sale", sale);
      addBtn.disabled = !v.available; addLabel.textContent = v.available ? FX.t.addToCart : FX.t.soldOut;
      show(v.media);
      if (fromTable) selects.forEach((s, i) => { s.value = v.options[i]; });
      rows.forEach(r => r.classList.toggle("is-current", r.dataset.sku === v.sku));
      const u = new URL(location.href); u.searchParams.set("variant", v.id); history.replaceState(null, "", u);
    };
    selects.forEach(s => s.addEventListener("change", () => {
      const vals = selects.map(x => x.value);
      setVariant(data.variants.find(v => v.options.every((o, i) => o === vals[i])));
    }));

    // açıklamadaki varyant tablosu: kaydırılabilir + satır tıklanınca seç
    if (desc) {
      $$("table", desc).forEach(t => {
        if (t.parentElement.classList.contains("fx-tablewrap")) return;
        const w = document.createElement("div"); w.className = "fx-tablewrap"; t.before(w); w.append(t);
      });
      const vt = $("table.fx-variants", desc);
      if (vt) {
        rows = $$("tbody tr", vt);
        rows.forEach(r => {
          r.dataset.sku = r.cells[0].textContent.trim();
          r.tabIndex = 0;
          const pick = () => {
            const v = data.variants.find(x => x.sku === r.dataset.sku);
            if (v) { setVariant(v, true); pdp.scrollIntoView({ behavior: "smooth", block: "start" }); }
          };
          r.addEventListener("click", pick);
          r.addEventListener("keydown", e => { if (e.key === "Enter") pick(); });
        });
        const cur = data.variants.find(v => v.id == idInput.value);
        cur && rows.forEach(r => r.classList.toggle("is-current", r.dataset.sku === cur.sku));
      }
    }

    form && form.addEventListener("submit", e => { e.preventDefault(); addToCart(idInput.value, qty.value, addBtn); });
  }

  /* ---------- Benzer ürünler ---------- */
  $$("[data-related]").forEach(async el => {
    if (el.children.length && el.querySelector(".fx-card")) return;
    try {
      const r = await fetch(el.dataset.url); const h = await r.text();
      const n = new DOMParser().parseFromString(h, "text/html").querySelector("[data-related]");
      if (n && n.innerHTML.trim()) el.innerHTML = n.innerHTML;
    } catch (e) {}
  });

  /* ---------- Filtreler & sıralama ---------- */
  const side = $("[data-filters]");
  const closeFilters = () => { if (side && side.classList.contains("is-open")) { side.classList.remove("is-open"); document.body.classList.remove("fx-lock"); } };
  document.addEventListener("click", e => {
    if (e.target.closest("[data-filters-open]")) { side.classList.add("is-open"); document.body.classList.add("fx-lock"); }
    if (e.target.closest("[data-filters-close]")) { const pending = side.dataset.pending; closeFilters(); if (pending) location.href = pending; }
  });
  const facets = $("[data-facets]");
  const desktop = () => matchMedia("(min-width: 990px)").matches;
  const facetUrl = () => {
    const p = new URLSearchParams(new FormData(facets));
    for (const [k, v] of [...p]) if (v === "") p.delete(k);
    const sort = $("[data-sort]"); if (sort) p.set("sort_by", sort.value);
    return `${location.pathname}?${p}`;
  };
  if (facets) {
    let t;
    facets.addEventListener("change", () => {
      const url = facetUrl();
      if (desktop()) { $("[data-plp]")?.classList.add("is-loading"); clearTimeout(t); t = setTimeout(() => { location.href = url; }, 250); }
      else side.dataset.pending = url;
    });
    facets.addEventListener("submit", e => { e.preventDefault(); location.href = facetUrl(); });
  }
  $$("[data-sort]").forEach(s => s.addEventListener("change", () => {
    const u = new URL(location.href); u.searchParams.set("sort_by", s.value); u.searchParams.delete("page"); location.href = u;
  }));

  /* ---------- İletişim formu: ürün sorgusunu doldur ---------- */
  const body = $("[data-contact-body]");
  if (body && !body.value) {
    const p = new URLSearchParams(location.search);
    if (p.get("product")) body.value = `${p.get("product")}${p.get("code") ? ` (${FX.t.code}: ${p.get("code")})` : ""}\n`;
  }
})();
